import { Get, Post } from '../requestBuilder/buildFetchRequest';
import PagedResponse from '../PagedResponse';
import PunchIn from './PunchIn';
import PunchInQueryOptions from './PunchInQueryOptions';
import StopPunchInRequest from './StopPunchInRequest';
import StartPunchInRequest from './StartPunchInRequest';
import { GroupedQueryParameters, buildGroupQueryParams } from '../GroupedQueryParameters';
import { QueryParameters, buildQueryParams } from '../QueryParameters';

export const getPunchInsGroups = (query: GroupedQueryParameters<PunchIn, PunchInQueryOptions>): Promise<PagedResponse<PunchIn>> => (
  Get('/api/punchIns/$groups')
    .AddQueryParams(buildGroupQueryParams(query))
    .Execute()
);

export const getPunchIns = (query: QueryParameters<PunchIn, PunchInQueryOptions>): Promise<PagedResponse<PunchIn>> => (
  Get('/api/punchIns')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getMyPunchInsGroups = (query: GroupedQueryParameters<PunchIn, Omit<PunchInQueryOptions, 'employeeId'>>): Promise<PagedResponse<PunchIn>> => (
  Get('/api/my/punchIns/$groups')
    .AddQueryParams(buildGroupQueryParams(query))
    .Execute()
);

export const getMyPunchIns = (query: QueryParameters<PunchIn, Omit<PunchInQueryOptions, 'employeeId'>>): Promise<PagedResponse<PunchIn>> => (
  Get('/api/my/punchIns')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getPunchIn = (id: number): Promise<PunchIn> => (
  Get(`/api/punchIns/${id}`)
    .Execute()
);

export const startMyPunchIn = (request: StartPunchInRequest): Promise<{ id: number }> => (
  Post('/api/my/punchIns/start')
    .AddBody(request)
    .Execute()
);

export const stopMyPunchIn = (id: number, request: StopPunchInRequest): Promise<void> => (
  Post(`/api/my/punchIns/${id}/stop`)
    .AddBody(request)
    .Execute()
);

export const stopPunchIn = (id: number, request: StopPunchInRequest): Promise<void> => (
  Post(`/api/punchIns/${id}/stop`)
    .AddBody(request)
    .Execute()
);

export const cancelMyPunchIn = (id: number): Promise<void> => (
  Post(`/api/my/punchIns/${id}/cancel`)
    .Execute()
);

export const cancelPunchIn = (id: number): Promise<void> => (
  Post(`/api/punchIns/${id}/cancel`)
    .Execute()
);

export const punchInGroupableColumns: (keyof PunchIn)[] = [
  'ardocDetailId',
  'comments',
  'completedReason',
  'custom1',
  'custom2',
  'custom3',
  'custom4',
  'custom5',
  'custom6',
  'custom7',
  'custom8',
  'elapsedMinutes',
  'empNumber',
  'employeeFirstName',
  'employeeId',
  'employeeLastName',
  'endTime',
  'hourClass',
  'hourDrawing',
  'hourFactor',
  'hourRate',
  'hourTypeId',
  'hourTypeName',
  'nonConformanceId',
  'nonConformanceName',
  'processScheduleDetailId',
  'processScheduleDetailName',
  'projectId',
  'projectName',
  'punchInCoords',
  'punchInIP',
  'punchOutCoords',
  'punchOutIP',
  'specId',
  'specName',
  'startTime',
];

export const punchInFilterableColumns: (keyof PunchInQueryOptions)[] = [
  'active',
  'comments',
  'custom1',
  'custom2',
  'custom3',
  'custom4',
  'custom5',
  'custom6',
  'custom7',
  'custom8',
  'employeeFirstName',
  'employeeId',
  'employeeLastName',
  'endTime',
  'hourTypeId',
  'hourTypeName',
  'nonConformanceId',
  'nonConformanceName',
  'processScheduleDetailId',
  'processScheduleDetailName',
  'projectId',
  'projectName',
  'specId',
  'specName',
  'startTime',
];

export const punchInSortableColumns: (keyof PunchIn)[] = [
  ...punchInGroupableColumns,
  'id',
];
